import defaultColors from '@elegantstack/solid-ui-theme/src/colors'

import customColours from '../../colours';

export default {
  ...defaultColors,
  ...customColours,
}
